import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FirmService } from '../../../Services/firm.service';
import { NgFor, NgIf } from '@angular/common';
import { Country } from '../../../Models/country';
import { HttpParams } from '@angular/common/http';
import { UserServiceService } from '../../../Services/user.service';
import { NotificationService } from '../../../Services/notification.service';
import { Router } from '@angular/router';
import { UserCustomerService } from '../../../Services/User/Customer/user-customer.service';
import { UserStaffService } from '../../../Services/User/Staff/user-staff.service';
import { forkJoin } from 'rxjs';
import { UserSupplierService } from '../../../Services/User/Supplier/user-supplier.service';
import { UserInvestorService } from '../../../Services/User/Investor/user-investor.service';
import { Validators } from '@angular/forms';
import { AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import intlTelInput from 'intl-tel-input';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { FirmSelectionService } from '../../../Services/firm-selection.service';


@Component({
  selector: 'app-home-user',
  imports: [ReactiveFormsModule, NgFor, NgIf, FormsModule],
  templateUrl: './home-user.component.html',
  styleUrl: './home-user.component.css'
})
export class HomeUserComponent implements OnInit, AfterViewInit {
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  itiInstance: any;   // ✅ Store intl-tel-input instance
  phoneInstance: any = null;
  userForm!: FormGroup;
  firmTypes: any[] = [];
  countries: Country[] = [];
  states: any[] = [];
  cities: any[] = [];
  nameSearch: string = '';
  mobileSearch: string = '';
  firmSearch: string = '';
  filteredCustomers: any[] = [];
  customerData: any;
  searchText: string = '';
  showDropdown = false;
  customerId: any;
  customerTypes: string[] = ['Wholesale', 'Retailer', 'Direct Customer', 'Family', 'Friend'];
  previewImages: { name: string, url: string }[] = [];
  hoveredImage: { name: string, url: string } | null = null;
  selectedFile: File | null = null;
  staffData: any;
  isOtpSent = false;
  isOtpVerified = false;
  isCityModalOpen = false;
  newCityName: string = '';

  constructor(
    private fb: FormBuilder,
    private firmService: FirmService,
    private userService: UserServiceService,
    private notificationService: NotificationService,
    private userCustomerService: UserCustomerService,
    private router: Router,
    private userStaffService: UserStaffService,
    private userSupplierService: UserSupplierService,
    private userInvestorService: UserInvestorService,
    private firmSelectionService: FirmSelectionService,
    @Inject(PLATFORM_ID) private platformId: object   // ✅ THIS LINE FIXES THE ERROR
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.listenFirmChange();
    this.loadFirmList();
    this.fetchCountries();
    this.getCustomerData();
  }

  navigateToUdhar() {
    this.router.navigate(['/udhar-list']);
  }
  //added by pratik
  navigateToAccounts() {
    this.router.navigate(['/accounts']);
  }

  initForm() {
    const firmId = localStorage.getItem('firm_id');

    this.userForm = this.fb.group({
      user_title: [''],
      name: ['', Validators.required],
      user_last_name: [''],
      mobilenumber: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{6,15}$/)  // ✅ International safe
      ]],


      user_secondary_mobile_no: [''],
      user_aadhar_card_no: [''],
      user_pan_card_no: [''],
      doc_user_img: [''],
      user_firm_id: [firmId ?? ''],
      user_customer_type: ['', Validators.required],
      user_trade_name: [''],
      user_middle_name: [''],
      country_id: [''],
      city_id: [''],
      state_id: [''],
      gstnumber: [''],
      user_gender: [''],
      email: [''],
      pincode: [''],
      address: [''],
      otp: [''],

    })
  }

  listenFirmChange() {
    this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      if (firm?.id) {
        // ✅ Update form control
        this.userForm.patchValue({
          user_firm_id: firm.id
        });
      }
    });
  }

  loadFirmList() {
    this.firmService.getFirms().subscribe((res: any) => {

      // Only NON-GST firms
      this.firmTypes = res.data.filter((firm: any) =>
        firm.gst_status === 'non-registered'
      );

    });
  }

  fetchCountries() {
    const params = new HttpParams();

    this.userService.getCountries(params).subscribe(
      (response: any) => {
        this.countries = response.data;

        // ✅ Find India and patch it as the bydefault country
        // Author : Pratik
        const india = this.countries.find(
          (country: any) => country.name?.toLowerCase() === 'india'
        );

        if (india) {
          this.userForm.patchValue({
            country_id: india.id
          });

          // Optional: Load states automatically
          this.onCountryChange();
        }
      },
      (error) => {
        console.error('Error fetching countries:', error);
        this.notificationService.showError(
          'Failed to fetch countries. Please try again.',
          'Error'
        );
      }
    );
  }

  fetchStates(countryId: number, callbackFunction: any = null) {
    const params = new HttpParams().set('country_id', countryId.toString());
    this.userService.getStates(params).subscribe(
      (response: any) => {
        this.states = response.data;
        this.cities = []; // Clear cities when new states are loaded
        this.userForm.controls['state_id'].setValue(''); // Clear state selection when new states arrive
        this.userForm.controls['city_id'].setValue(''); // Clear city selection

        if (callbackFunction) {
          callbackFunction();
        }
      },
      (error) => {
        this.notificationService.showError(
          'Failed to fetch states. Please try again.',
          'Error'
        );
      }
    );
  }

  onCountryChange() {
    const countryId = this.userForm.controls['country_id'].value;
    if (countryId) {
      this.fetchStates(countryId);
      const selectedCountry = this.countries.find((c) => c.id === +countryId);
      if (selectedCountry) {
        this.userForm.patchValue({
          currency_code: selectedCountry.currency, // Assuming you have a currency_code control
        });
      }
    } else {
      this.states = [];
      this.cities = [];
      this.userForm.controls['state_id'].setValue('');
      this.userForm.controls['city_id'].setValue('');
    }
  }

  onStateChange() {
    const stateId = this.userForm.controls['state_id'].value;
    if (stateId) {
      this.fetchCities(stateId);
    } else {
      this.cities = [];
      this.userForm.controls['city_id'].setValue('');
    }
  }

  fetchCities(stateId: number) {
    const params = new HttpParams().set('state_id', stateId.toString());
    this.userService.getCities(params).subscribe(
      (response: any) => {
        this.cities = response.data;
        this.userForm.controls['city_id'].setValue('');
      },
      (error) => {
        this.notificationService.showError(
          'Failed to fetch cities. Please try again.',
          'Error'
        );
      }
    );
  }

  filterCustomers() {
    const name = this.nameSearch.trim().toLowerCase();
    const mobile = this.mobileSearch.trim();
    const firm = this.firmSearch.trim().toLowerCase();

    if (name || mobile || firm) {
      this.filteredCustomers = this.customerData
        .filter((cust: any) => {

          /* NAME FILTER */
          const nameMatch = name
            ? cust.name?.toLowerCase().startsWith(name)
            : true;

          /* MOBILE FILTER */
          const storedMobileDigits = cust.mobilenumber
            ? cust.mobilenumber.toString().replace(/\D/g, '')
            : '';
          const mobileMatch = mobile
            ? storedMobileDigits.includes(mobile)
            : true;

          /* FIRM NAME FILTER */
          const firmMatch = firm
            ? (cust.user_trade_name ?? '').toLowerCase().includes(firm)
            : true;

          return nameMatch && mobileMatch && firmMatch;
        })
        .slice(0, 5);
    } else {
      this.filteredCustomers = [];
    }
  }


  getCustomerData() {
    const params = new HttpParams();

    forkJoin({
      customers: this.userCustomerService.getUserCustomers(params),
      staff: this.userStaffService.getUserStaff(),
      supplier: this.userSupplierService.getUserSupplier(params),
      investor: this.userInvestorService.getUserInvestor()
    }).subscribe((result: any) => {
      this.customerData = [
        ...result.customers.data,
        ...result.staff.data,
        ...result.supplier.data,
        ...result.investor.data
      ];
    });
  }

  filterCustomersByName(event?: Event) {
    this.nameSearch = (event?.target as HTMLInputElement)?.value || '';
    this.filterCustomers();
  }

  filterCustomersByMobile(event?: Event) {
    this.mobileSearch = (event?.target as HTMLInputElement)?.value || '';
    this.filterCustomers();
  }

  filterCustomersByFirm(event?: Event) {
    this.firmSearch = (event?.target as HTMLInputElement)?.value || '';
    this.filterCustomers();
  }

  selectCustomer(customer: any) {
    this.searchText = `${customer.name} ${customer.user_last_name || ''}`;
    this.showDropdown = false;
    this.onCustomerSelected(customer);
  }

  onCustomerSelected(customer: any) {
    this.customerId = customer.id;
    if (this.customerId && (customer.user_customer_type === 'Retailer' || customer.user_customer_type === 'Wholesale')) {
      this.router.navigate([
        `/sell-details-lot/${this.customerId}`
      ]);
    } else {
      this.router.navigate([
        // `/sell-details/customer/${this.customerId}/sell-details`
        `/sell-details-lot/${this.customerId}`
      ]);
    }
  }

  onSellButtonClick() {
    this.createCustomerFromHome('sell');
  }

  onHomeButtonClick() {
    this.createCustomerFromHome('home');
  }

  private createCustomerFromHome(action: 'sell' | 'home') {
    const nameControl = this.userForm.get('name');
    const mobileControl = this.userForm.get('mobilenumber');

    if (!nameControl || !nameControl.value || nameControl.invalid) {
      nameControl?.markAsTouched();
      this.notificationService.showError(
        'Please enter the first name',
        'Validation Error'
      );
      const nameInput = document.getElementById('name') as HTMLInputElement | null;
      nameInput?.focus();
      return;
    }

    const customerTypeControl = this.userForm.get('user_customer_type');
    if (!customerTypeControl || !customerTypeControl.value || customerTypeControl.invalid) {
      customerTypeControl?.markAsTouched();
      this.notificationService.showError(
        'Please select customer type',
        'Validation Error'
      );
      const customerTypeSelect = document.getElementById('user_customer_type') as HTMLSelectElement | null;
      customerTypeSelect?.focus();
      return;
    }

    const mobileDigits = (mobileControl?.value ?? '').toString().trim();
    if (!mobileDigits || mobileControl?.invalid) {
      mobileControl?.markAsTouched();
      this.notificationService.showError(
        'Please enter a valid mobile number',
        'Validation Error'
      );
      document.getElementById('mobilenumber')?.focus();
      return;
    }

    const countryId = this.userForm.get('country_id')?.value;
    if (!countryId) {
      this.userForm.get('country_id')?.markAsTouched();
      this.notificationService.showError('Please select a Country', 'Validation Error');
      return;
    }

    const stateId = this.userForm.get('state_id')?.value;
    if (!stateId) {
      this.userForm.get('state_id')?.markAsTouched();
      this.notificationService.showError('Please select a State', 'Validation Error');
      document.getElementById('state')?.focus();
      return;
    }

    const cityId = this.userForm.get('city_id')?.value;
    if (!cityId) {
      this.userForm.get('city_id')?.markAsTouched();
      this.notificationService.showError('Please select a City', 'Validation Error');
      document.getElementById('city')?.focus();
      return;
    }

    const formData = new FormData();

    Object.keys(this.userForm.value).forEach(key => {
      if (key !== 'mobilenumber') {
        formData.append(key, this.userForm.value[key] ?? '');
      }
    });

    let fullMobileNumber = mobileDigits;
    if (this.itiInstance) {
      const countryData = this.itiInstance.getSelectedCountryData();
      const dialCode = countryData?.dialCode ? `+${countryData.dialCode}` : '';
      fullMobileNumber = dialCode + mobileDigits;
    }

    formData.append('mobilenumber', fullMobileNumber);

    if (this.selectedFile) {
      formData.append(
        'doc_user_img',
        this.selectedFile,
        this.selectedFile.name
      );
    }

    this.userCustomerService.createUserCustomer(formData).subscribe({
      next: (res: any) => {
        this.customerId = res.data.id;

        this.notificationService.showSuccess(
          'Customer created successfully!',
          'Success'
        );

        if (action === 'sell') {
          this.router.navigate([`/sell-details-lot/${res.data.id}`]);
          return;
        }

        this.resetHomeCustomerForm();
        this.getCustomerData();
      },
      error: (err: any) => {
        console.error('Error creating customer:', err);
      }
    });
  }

  private resetHomeCustomerForm() {
    const firmId = this.userForm.get('user_firm_id')?.value || localStorage.getItem('firm_id') || '';
    const countryId = this.userForm.get('country_id')?.value || '';

    this.userForm.reset({
      user_title: '',
      name: '',
      user_last_name: '',
      mobilenumber: '',
      user_secondary_mobile_no: '',
      user_aadhar_card_no: '',
      user_pan_card_no: '',
      doc_user_img: '',
      user_firm_id: firmId,
      user_customer_type: '',
      user_trade_name: '',
      user_middle_name: '',
      country_id: countryId,
      city_id: '',
      state_id: '',
      gstnumber: '',
      user_gender: '',
      email: '',
      pincode: '',
      address: '',
      otp: '',
    });

    this.selectedFile = null;
    this.previewImages = [];
    this.cities = [];

    if (countryId) {
      this.fetchStates(countryId);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    this.selectedFile = file; // keep file for payload

    this.previewImages = [];

    const reader = new FileReader();
    reader.onload = () => {
      this.previewImages.push({ name: file.name, url: reader.result as string });
    };
    reader.readAsDataURL(file);
  }

  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === 'Enter') {
      keyboardEvent.preventDefault();
      const target = keyboardEvent.target as HTMLElement;
      const form = target.closest('form');
      if (!form) return;
      const focusable = Array.from(
        form.querySelectorAll<HTMLElement>('input, select, textarea, button')
      ).filter(el => !el.hasAttribute('disabled') && el.tabIndex !== -1);
      const index = focusable.indexOf(target);
      if (index > -1 && index + 1 < focusable.length) {
        focusable[index + 1].focus();
      }
    }
  }

  onMobileInput(event: Event) {
    const input = event.target as HTMLInputElement;

    // ✅ Read raw input
    let rawValue = input.value;

    // ✅ Extract digits & letters
    const digitsOnly = rawValue.replace(/[^0-9]/g, '');
    const lettersOnly = rawValue.replace(/[^a-zA-Z]/g, '');

    // ✅ Get selected country SAFELY
    const countryData = this.phoneInstance?.getSelectedCountryData();
    const selectedCountry = countryData?.iso2 ?? 'in';

    /* =========================
       ENFORCE DIGIT LIMIT FIRST
       (THIS IS THE KEY FIX ✅)
    ========================== */
    let finalNumber = digitsOnly;

    if (selectedCountry === 'in') {
      finalNumber = finalNumber.slice(0, 10); // ✅ HARD LIMIT
    } else {
      finalNumber = finalNumber.slice(0, 15); // ✅ HARD LIMIT
    }

    /* =========================
       MOVE LETTERS → FIRST NAME
    ========================== */
    if (lettersOnly) {
      const nameControl = this.userForm.get('name');
      const existingName = (nameControl?.value ?? '').replace(/\s+/g, '');

      const updatedName = existingName
        ? existingName + lettersOnly
        : lettersOnly;

      nameControl?.setValue(updatedName, { emitEvent: false });

      // ✅ keep filtering logic
      this.nameSearch = updatedName.toLowerCase();
      this.filterCustomers();

      // ✅ focus first name cleanly
      setTimeout(() => {
        document.getElementById('name')?.focus();
      }, 0);
    }

    /* =========================
       UPDATE INPUT + FORM
    ========================== */
    input.value = finalNumber;

    this.userForm.get('mobilenumber')?.setValue(finalNumber, {
      emitEvent: false,
    });

    // ✅ keep mobile filtering
    this.mobileSearch = finalNumber;
    this.filterCustomers();
  }


  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    setTimeout(() => {
      if (!this.phoneInput?.nativeElement) return;

      this.itiInstance = intlTelInput(this.phoneInput.nativeElement, {
        initialCountry: 'in',
        separateDialCode: true,
        preferredCountries: ['in', 'us', 'ae', 'gb'],
      } as any);

    }, 0);
  }
  sendOtp() {
    const mobile = this.userForm.get('mobilenumber')?.value?.trim();

    if (!mobile) {
      this.notificationService.showError('Please enter mobile number first!', 'Validation Error');
      return;
    }

    if (!/^\d{10}$/.test(mobile)) {
      this.notificationService.showError('Please enter a valid 10-digit mobile number!', 'Validation Error');
      return;
    }

    this.userService.sendOtp(mobile).subscribe({
      next: (res) => {
        if (res.success) {
          this.notificationService.showSuccess(`✅ OTP sent successfully to ${mobile}`, 'Success');
          this.isOtpSent = true;
        } else {
          this.notificationService.showError('❌ Failed to send OTP!', 'validation erro');
        }
      },
      error: () => {
        this.notificationService.showError('❌ Error while sending OTP!', 'Validation Error');
      }
    });
  }

  verifyOtp() {
    const enteredOtp = this.userForm.get('otp')?.value?.trim();

    if (!enteredOtp) {
      this.notificationService.showError('Please enter the OTP!', 'Success');
      return;
    }

    this.userService.verifyOtp(enteredOtp).subscribe({
      next: (res) => {
        if (res.success) {
          this.notificationService.showSuccess('✅ OTP Verified Successfully!', 'Success');
        } else {
          this.notificationService.showError(`❌ ${res.message}`, 'Validation error');
        }
      },
      error: () => {
        this.notificationService.showError('❌ Error verifying OTP!', 'Validation Error ');
      }
    });
  }

  openCityModal() {
    const countryId = this.userForm.get('country_id')?.value;
    const stateId = this.userForm.get('state_id')?.value;

    if (!countryId || !stateId) {
      this.notificationService.showError('Please select Country and State first', 'Validation Error');
      return;
    }
    this.isCityModalOpen = true;
  }

  closeCityModal() {
    this.isCityModalOpen = false;
    this.newCityName = '';
  }

  addCity() {
    if (!this.newCityName.trim()) {
      this.notificationService.showError('Please enter City/Town name', 'Validation Error');
      return;
    }

    const payload = {
      name: this.newCityName.trim(),
      country_id: this.userForm.get('country_id')?.value,
      state_id: this.userForm.get('state_id')?.value
    };

    this.userService.createCity(payload).subscribe({
      next: (res: any) => {
        this.notificationService.showSuccess('City created successfully', 'Success');
        const newCity = res.data;

        // Ensure cities array exists and add the new city
        if (!this.cities) this.cities = [];
        this.cities.push(newCity);

        // Select the new city
        this.userForm.patchValue({ city_id: newCity.id });

        this.closeCityModal();
      },
      error: (err) => {
        this.notificationService.showError('Failed to create city', 'Error');
        console.error(err);
      }
    });
  }


}
